"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconForContentType = exports.IconType = exports.LineageItemType = void 0;
var DataCatalogLineageDashboard_1 = require("../../../gen-src/icons/DataCatalogLineageDashboard");
var DataCatalogLineageDashboardActive_1 = require("../../../gen-src/icons/DataCatalogLineageDashboardActive");
var DataCatalogLineageDashboardWhite_1 = require("../../../gen-src/icons/DataCatalogLineageDashboardWhite");
var DataCatalogLineageDs_1 = require("../../../gen-src/icons/DataCatalogLineageDs");
var DataCatalogLineageDsActive_1 = require("../../../gen-src/icons/DataCatalogLineageDsActive");
var DataCatalogLineageDsWhite_1 = require("../../../gen-src/icons/DataCatalogLineageDsWhite");
var DataCatalogLineageFlow_1 = require("../../../gen-src/icons/DataCatalogLineageFlow");
var DataCatalogLineageFlowActive_1 = require("../../../gen-src/icons/DataCatalogLineageFlowActive");
var DataCatalogLineageFlowWhite_1 = require("../../../gen-src/icons/DataCatalogLineageFlowWhite");
var DataCatalogLineageLens_1 = require("../../../gen-src/icons/DataCatalogLineageLens");
var DataCatalogLineageLensActive_1 = require("../../../gen-src/icons/DataCatalogLineageLensActive");
var DataCatalogLineageLensWhite_1 = require("../../../gen-src/icons/DataCatalogLineageLensWhite");
var DataCatalogLineageMetric_1 = require("../../../gen-src/icons/DataCatalogLineageMetric");
var DataCatalogLineageMetricActive_1 = require("../../../gen-src/icons/DataCatalogLineageMetricActive");
var DataCatalogLineageMetricWhite_1 = require("../../../gen-src/icons/DataCatalogLineageMetricWhite");
var DataCatalogLineageServer_1 = require("../../../gen-src/icons/DataCatalogLineageServer");
var DataCatalogLineageServerActive_1 = require("../../../gen-src/icons/DataCatalogLineageServerActive");
var DataCatalogLineageServerWhite_1 = require("../../../gen-src/icons/DataCatalogLineageServerWhite");
var DataCatalogLineageSheet_1 = require("../../../gen-src/icons/DataCatalogLineageSheet");
var DataCatalogLineageSheetActive_1 = require("../../../gen-src/icons/DataCatalogLineageSheetActive");
var DataCatalogLineageSheetWhite_1 = require("../../../gen-src/icons/DataCatalogLineageSheetWhite");
var DataCatalogLineageTable_1 = require("../../../gen-src/icons/DataCatalogLineageTable");
var DataCatalogLineageTableActive_1 = require("../../../gen-src/icons/DataCatalogLineageTableActive");
var DataCatalogLineageTableWhite_1 = require("../../../gen-src/icons/DataCatalogLineageTableWhite");
var DataCatalogLineageUsers_1 = require("../../../gen-src/icons/DataCatalogLineageUsers");
var DataCatalogLineageUsersActive_1 = require("../../../gen-src/icons/DataCatalogLineageUsersActive");
var DataCatalogLineageUsersWhite_1 = require("../../../gen-src/icons/DataCatalogLineageUsersWhite");
var DataCatalogLineageVirtualConnection_1 = require("../../../gen-src/icons/DataCatalogLineageVirtualConnection");
var DataCatalogLineageVirtualConnectionActive_1 = require("../../../gen-src/icons/DataCatalogLineageVirtualConnectionActive");
var DataCatalogLineageVirtualConnectionTable_1 = require("../../../gen-src/icons/DataCatalogLineageVirtualConnectionTable");
var DataCatalogLineageVirtualConnectionTableActive_1 = require("../../../gen-src/icons/DataCatalogLineageVirtualConnectionTableActive");
var DataCatalogLineageVirtualConnectionTableWhite_1 = require("../../../gen-src/icons/DataCatalogLineageVirtualConnectionTableWhite");
var DataCatalogLineageVirtualConnectionWhite_1 = require("../../../gen-src/icons/DataCatalogLineageVirtualConnectionWhite");
var DataCatalogLineageWorkbook_1 = require("../../../gen-src/icons/DataCatalogLineageWorkbook");
var DataCatalogLineageWorkbookActive_1 = require("../../../gen-src/icons/DataCatalogLineageWorkbookActive");
var DataCatalogLineageWorkbookWhite_1 = require("../../../gen-src/icons/DataCatalogLineageWorkbookWhite");
var SchemaViewerBlank_1 = require("../../../gen-src/icons/SchemaViewerBlank");
var LineageItemType;
(function (LineageItemType) {
    LineageItemType["Dashboard"] = "dashboard";
    LineageItemType["Database"] = "database";
    LineageItemType["Datasource"] = "datasource";
    LineageItemType["Flow"] = "flow";
    LineageItemType["Lens"] = "lens";
    LineageItemType["Metric"] = "metric";
    LineageItemType["Sheet"] = "sheet";
    LineageItemType["Table"] = "table";
    LineageItemType["User"] = "user";
    LineageItemType["VirtualConnection"] = "virtualConnection";
    LineageItemType["VirtualConnectionTable"] = "virtualConnectionTable";
    LineageItemType["Workbook"] = "workbook";
})(LineageItemType = exports.LineageItemType || (exports.LineageItemType = {}));
var IconType;
(function (IconType) {
    IconType["inactive"] = "inactive";
    IconType["active"] = "active";
    IconType["white"] = "white";
})(IconType = exports.IconType || (exports.IconType = {}));
var activeIcons = {
    dashboard: DataCatalogLineageDashboardActive_1.SvgDataCatalogLineageDashboardActive,
    database: DataCatalogLineageServerActive_1.SvgDataCatalogLineageServerActive,
    datasource: DataCatalogLineageDsActive_1.SvgDataCatalogLineageDsActive,
    flow: DataCatalogLineageFlowActive_1.SvgDataCatalogLineageFlowActive,
    lens: DataCatalogLineageLensActive_1.SvgDataCatalogLineageLensActive,
    metric: DataCatalogLineageMetricActive_1.SvgDataCatalogLineageMetricActive,
    sheet: DataCatalogLineageSheetActive_1.SvgDataCatalogLineageSheetActive,
    table: DataCatalogLineageTableActive_1.SvgDataCatalogLineageTableActive,
    user: DataCatalogLineageUsersActive_1.SvgDataCatalogLineageUsersActive,
    virtualConnection: DataCatalogLineageVirtualConnectionActive_1.SvgDataCatalogLineageVirtualConnectionActive,
    virtualConnectionTable: DataCatalogLineageVirtualConnectionTableActive_1.SvgDataCatalogLineageVirtualConnectionTableActive,
    workbook: DataCatalogLineageWorkbookActive_1.SvgDataCatalogLineageWorkbookActive,
};
var inactiveIcons = {
    dashboard: DataCatalogLineageDashboard_1.SvgDataCatalogLineageDashboard,
    database: DataCatalogLineageServer_1.SvgDataCatalogLineageServer,
    datasource: DataCatalogLineageDs_1.SvgDataCatalogLineageDs,
    flow: DataCatalogLineageFlow_1.SvgDataCatalogLineageFlow,
    lens: DataCatalogLineageLens_1.SvgDataCatalogLineageLens,
    metric: DataCatalogLineageMetric_1.SvgDataCatalogLineageMetric,
    sheet: DataCatalogLineageSheet_1.SvgDataCatalogLineageSheet,
    table: DataCatalogLineageTable_1.SvgDataCatalogLineageTable,
    user: DataCatalogLineageUsers_1.SvgDataCatalogLineageUsers,
    virtualConnection: DataCatalogLineageVirtualConnection_1.SvgDataCatalogLineageVirtualConnection,
    virtualConnectionTable: DataCatalogLineageVirtualConnectionTable_1.SvgDataCatalogLineageVirtualConnectionTable,
    workbook: DataCatalogLineageWorkbook_1.SvgDataCatalogLineageWorkbook,
};
var whiteIcons = {
    dashboard: DataCatalogLineageDashboardWhite_1.SvgDataCatalogLineageDashboardWhite,
    database: DataCatalogLineageServerWhite_1.SvgDataCatalogLineageServerWhite,
    datasource: DataCatalogLineageDsWhite_1.SvgDataCatalogLineageDsWhite,
    flow: DataCatalogLineageFlowWhite_1.SvgDataCatalogLineageFlowWhite,
    lens: DataCatalogLineageLensWhite_1.SvgDataCatalogLineageLensWhite,
    metric: DataCatalogLineageMetricWhite_1.SvgDataCatalogLineageMetricWhite,
    sheet: DataCatalogLineageSheetWhite_1.SvgDataCatalogLineageSheetWhite,
    table: DataCatalogLineageTableWhite_1.SvgDataCatalogLineageTableWhite,
    user: DataCatalogLineageUsersWhite_1.SvgDataCatalogLineageUsersWhite,
    virtualConnection: DataCatalogLineageVirtualConnectionWhite_1.SvgDataCatalogLineageVirtualConnectionWhite,
    virtualConnectionTable: DataCatalogLineageVirtualConnectionTableWhite_1.SvgDataCatalogLineageVirtualConnectionTableWhite,
    workbook: DataCatalogLineageWorkbookWhite_1.SvgDataCatalogLineageWorkbookWhite,
};
function getIconForContentType(contentType, iconType) {
    var iconDirectory = iconType === IconType.active ? activeIcons :
        iconType === IconType.white ? whiteIcons :
            inactiveIcons;
    return iconDirectory[contentType] || SchemaViewerBlank_1.SvgSchemaViewerBlank;
}
exports.getIconForContentType = getIconForContentType;
//# sourceMappingURL=LineageItemType.js.map